import React, { useState, useRef, useEffect } from 'react';
import { Slider } from '@mui/material';

const ResolutionSliderDropdown = ({ resolutionRange, setResolutionRange, disabled }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen]);

  return (
    <div ref={dropdownRef} style={{ position: 'relative', flex: 1 }}>
<div
  onClick={() => !disabled && setIsOpen(!isOpen)}
  style={{
    width: '100%',
    backgroundColor: 'transparent',
    border: 'none',
    color: '#A6B6CE',
    fontSize: '13px',
    cursor: disabled ? 'not-allowed' : 'pointer',
    outline: 'none',
    padding: '4px 0',
    fontWeight: 'bold',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingRight: '16px',
  }}
>
  {/* Text: Resolution and range */}
  <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
    <span>Resolution:</span>
    <span style={{ fontStyle: 'italic', fontWeight: 'normal', fontSize: '12px' }}>
      {resolutionRange[0]}m – {resolutionRange[1]}m
    </span>
  </div>

  {/* Arrow icon */}
  <div
    style={{
      width: '16px',
      height: '16px',
      backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%23A6B6CE' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E")`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      backgroundSize: 'contain'
    }}
  />
</div>


      {isOpen && (
        <div style={{
          position: 'absolute',
          top: '100%',
          left: 0,
          width: '100%',
          backgroundColor: 'rgba(22, 22, 22, 0.95)',
          border: '1px solid rgba(166, 182, 206, 0.1)',
          borderRadius: '6px',
          padding: '12px',
          zIndex: 1000,
          boxShadow: '0 4px 10px rgba(0,0,0,0.3)',
        }}>
          <Slider
            value={resolutionRange}
            onChange={(e, newValue) => setResolutionRange(newValue)}
            valueLabelDisplay="auto"
            min={0}
            max={100}
            step={0.1}
            sx={{
              color: '#A6B6CE',
              height: '26px',
              '& .MuiSlider-thumb': {
                backgroundColor: '#A6B6CE',
                border: '2px solid #666',
                width: '12px',
                height: '12px',
              },
              '& .MuiSlider-track': { backgroundColor: '#666', height: '4px' },
              '& .MuiSlider-rail': { backgroundColor: '#333', height: '4px' },
              '& .MuiSlider-valueLabel': {
                backgroundColor: '#1E1E1E',
                color: '#A6B6CE',
                fontSize: '11px',
                borderRadius: '4px',
              }
            }}
          />
        </div>
      )}
    </div>
  );
};

export default ResolutionSliderDropdown;
